import { InvoiceErrorCode } from '../types/invoice';

const getInvoiceErrorMessage = (code: InvoiceErrorCode): string => {
    switch (code) {
        case 'orderNotCompleted':
            return 'El pedido no está completado';
        case 'invalidAmount':
            return 'El monto total es 0 o inválido';
        case 'missingBillingData':
            return 'Faltan datos de facturación';
        case 'noItems':
            return 'El pedido no tiene productos';
        case 'invalidNitFormat':
            return 'El formato del NIT es inválido';
        case 'nitNotFound':
            return 'El NIT no existe en los registros de SAT';
        case 'satValidationError':
            return 'Error de validación según normas SAT';
        case 'duplicateInvoice':
            return 'Esta factura ya fue certificada previamente';
        case 'infileRejection':
            return 'INFILE rechazó la certificación';
        case 'infileAuthError':
            return 'Error de autenticación con INFILE';
        case 'infileTimeout':
            return 'Tiempo de espera agotado esperando respuesta de INFILE';
        case 'infileNetworkError':
            return 'Error de conexión con INFILE';
        case 'infileServerError':
            return 'INFILE está experimentando problemas';
        case 'infileUnknownError':
            return 'Error desconocido al certificar con INFILE';
        case 'feelCredentialsError':
            return 'Error de credenciales FEEL';
        case 'feelLimitExceeded':
            return 'Límite diario de consultas FEEL excedido';
        case 'feelUnknownError':
            return 'Error desconocido en FEEL';
    }
};

export default getInvoiceErrorMessage;
